// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__AMf3L","consentsList":"PatientConsents_consentsList__2NuDi","consentsListEmpty":"PatientConsents_consentsListEmpty__31oW6"};